import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientExcursionManagement = async ({ rootGetters, commit }, clientSid) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getClientExcursionManagement(clientSid);
  if (response.data) {
    commit('setClientExcursionManagement', response.data);
  }
  return response;
};
